var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_c('a',{attrs:{"href":"#"},on:{"click":_vm.onClickMain}},[_c('strong',[_vm._v("鹿小編的每日精選")])])]),_c('p',[_vm._v(" 客服信箱: service@deardeeronline.com ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }